if(typeof require !== 'undefined'){
    require('flatpickr');
    const {Lithuanian} = require('flatpickr/dist/l10n/lt');
}

class CmsDatepicker {
    static init($context = null){
        var inputSelector = "[data-input='datepicker']:not([data-datepicker]), .datepickermdy";
        let $inputs = $context ? $context.find(inputSelector) : $(inputSelector);
        $inputs.each(function (index, element) {
            if($(element).data('datepicker_instance')) return;
            $(element).data('datepicker_instance', new CmsDatepicker($(element).data('options'), element))
        });
    }
    constructor(config, context) {
        let lang = document.documentElement.getAttribute('lang');
        let $input = $(context);

        if($input.prop('readonly')) return;

        var c = {
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true,
            dateFormat: 'Y-m-d',
            disableMobile: true,
            locale: flatpickr.l10ns[lang] ? flatpickr.l10ns[lang] : flatpickr.l10ns.default,
            //region čia pridėta
            onReady: function (_, __, fp) {
                if (config.dateFormat === 'Y') {
                    fp.calendarContainer.querySelector(".flatpickr-innerContainer").style.display = "none";
                    fp.calendarContainer.querySelector(".flatpickr-monthDropdown-months").style.display = "none";
                    //arrow left disable
                    fp.calendarContainer.querySelector(".flatpickr-prev-month").style.display = "none";
                    //arrow right disable
                    fp.calendarContainer.querySelector(".flatpickr-next-month").style.display = "none";
                    fp.currentMonth = 0;
                }
            },
            onYearChange: function (_, __, fp) {
                if (config.dateFormat === 'Y') {
                    fp.input.value = fp.currentYear;
                }
            }
            //endregion čia pridėta
        };
        $.extend(c, config);

        let instance = flatpickr(context, c);

        if($input.hasClass('date-range')){
            instance.config.onChange.push(function (selectedDates, dateStr, instance) {
                if($input.hasClass('date-range-from')){
                    let toInstance = $input.parent().find('.date-range-to')[0]._flatpickr;
                    toInstance.config.minDate = dateStr;
                }else if($input.hasClass('date-range-to')){
                    let toInstance = $input.parent().find('.date-range-from')[0]._flatpickr;
                    toInstance.config.maxDate = dateStr;
                }
            }.bind(this))
        }else{
            if(config.maxValueInput){
                let $maxValueInput = $(config.maxValueInput)
                $maxValueInput.on('change', function (){
                    instance.config.maxDate = this.value
                })
                if($maxValueInput.val()){
                    instance.config.maxDate = $maxValueInput.val()
                }
            }
            if(config.minValueInput){
                let $minValueInput = $(config.minValueInput)
                $minValueInput.on('change', function (){
                    instance.config.minDate = this.value
                })
                if($minValueInput.val()){
                    instance.config.minDate = $minValueInput.val()
                }
            }
        }
        if($input.next('button.clear-datetime').length) {
            $input.next('button.clear-datetime').on('click', function(){
                instance.clear();
            });
        }
    }
}


if (typeof module === "object" && typeof module.exports === "object"){
    CmsDatepicker.init()
    //node modules support
    module.exports = CmsDatepicker
}else{
    $(function(){
        CmsDatepicker.init()
    });
}
